import { apiHelper, PromiseHandler } from "../redux/apiHelper";
const getInquiryList = (data) =>
  PromiseHandler(
    apiHelper("get", "/api/user/inquiry/list")
  );
const getInquiryById = (id) =>
  PromiseHandler(
    apiHelper("get", `/api/user/inquiry/get/${id}`)
  );

const updateInquiries = (id, data) =>
  PromiseHandler(
    apiHelper("post", `/api/user/inquiry/update/${id}`, data)
  );
export {
    getInquiryList,
    getInquiryById,
    updateInquiries
};
